import { MainContentLayout } from 'shared/ui/layout';

import { EditBank } from 'features/bank/edit';

export function EditBankPage() {
  return <MainContentLayout element={<EditBank />} />;
}
